var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-quick-tour',{attrs:{"height":_vm.videoHeight,"video-name":"idea_validationVideo"}},[_c('h4',{staticClass:"my-3 my-xl-0 font-outfit-medium"},[_vm._v(" "+_vm._s(_vm.$t('sidebar.validation'))+" ")]),_c('div',{staticClass:"quick-tour-text",domProps:{"innerHTML":_vm._s(_vm.$t('ideaScoreQuickTourText'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }